import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { PatientFormGroup } from 'src/app/shared/patient-form/patient-form.model';

@Injectable({
  providedIn: 'root'
})
@Pipe({
  name: 'phone'
})
export class PhonePipe implements PipeTransform {
  transform(phone: string): string {
    if (phone) {
      const phoneAndCountryCode = PatientFormGroup.getCountryCodeAndPhoneNumberFromPhoneNumber(
        phone
      );

      return phoneAndCountryCode.countryCode + phoneAndCountryCode.phone;
    }
    return phone;
  }
}
